<template>
  <bar-code-view></bar-code-view>
</template>
<script>
import BarCodeScanView from "../components/BarCodeScanView";
export default {
  components: {
    "bar-code-view": BarCodeScanView
  }
};
</script>